import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  useMediaQuery,
  useTheme,
  Stack,
  IconButton,
  Typography,
  Divider,
  MenuItem,
  Snackbar,
  Alert,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../components/Theme";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import MapPolygonViewer from "./GoogleMapPolygonView"; 
import MapMarkerViewer from "./GoogleMapPinView";
import HandymanIcon from "@mui/icons-material/Handyman";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Durian_interval from "./durian_interval";
import DorkStateTable from "./dork_interval";
import Event from "./event";
import Stock from "./Stock";
import Event_image from "./event_image";
import CreateCrop from "../api/crop/CreateCrop";
import GetLand from "../api/land/GetLand";
import DeleteCrop from "../api/crop/DeleteCrop";
import GetCrop from "../api/crop/GetCrop";
import UpdateCrop from "../api/crop/UpdateCrop";
import GetFarm from "../api/farm/GetFarm";
const editableFields = [
  { key: "appLandId", label: "ที่ดิน" },
  { key: "cropYear", label: "ปี" },
  { key: "cropName", label: "ชื่อพืช" },
  { key: "breedName", label: "พันธุ์" },
  { key: "gapCertNumber", label: "เลขที่ GAP" },
  { key: "gapCertType", label: "ประเภท GAP" },
  { key: "certIssuedDate", label: "วันที่ออก" },
  { key: "certExpiryDate", label: "วันที่หมดอายุ" },
  { key: "startDate", label: "วันที่เริ่มรอบ" },
  { key: "endDate", label: "วันสินสุดรอบ" },
  { key: "pctPlantArea", label: "เปอร์เซ็นต์พื้นที่ปลูก" },
  { key: "totalTrees", label: "จำนวนต้น" },
  { key: "forecastKg", label: "คาดการณ์ผลผลิต" },
  { key: "forecastBaht", label: "เป้ายอดขาย(บาท)" },
  { key: "forecastBahtPerKg", label: "ราคาขาย(บาท/กก)" },
  { key: "forecastWorkerCost", label: "ต้นทุนแรงงาน" },
  { key: "forecastPetrolCost", label: "ต้นทุนเชื้อเพลิง" },
  { key: "forecastFertilizerCost", label: "ต้นทุนปุ๋ย" },
  { key: "forecastChemicalCost", label: "ต้นทุนยา/สารเคมี" },
  { key: "forecastEquipmentCost", label: "ต้นทุนอุปกรณ์" },
  { key: "durianStage", label: "ระยะของทุเรียน" },
  { key: "avgTreeAge", label: "อายุต้น(ปี)" },
  { key: "harvestRounds", label: "จำนวนรอบเก็บเกี่ยว" },
  { key: "area", label: "จำนวนไร่" },
  { key: "specificName", label: "ชื่อ" },
  { key: "plantType", label: "ชนิดพืช" },
  { key: "plantClass", label: "ประเภท" },
];

const payloadToRow = (payload) =>
  payload.map((item, index) => ({
    id: index + 1,
    ...item,
  }));
const extractappLandId = (data) => {
  if (!Array.isArray(data) || data.length === 0) return [];
  return data.map((item) => item.appLandId);
};

export default function CropGAP() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [rows, setRows] = React.useState(payloadToRow([]));
  const [openDialog, setOpenDialog] = React.useState(false);
  const [currentRow, setCurrentRow] = React.useState({});
  const [editIndex, setEditIndex] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedMenu, setSelectedMenu] = useState("dork_interval");
  const [appLandIdOptions, setAppLandIdOptions] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userdata"));
  const [selectedAppCropId, setSelectedAppCropId] = useState(null);
  const [dateCrop, setDateCrop] = useState(null);
  const [main, setMain] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [landPolygons, setLandPolygons] = useState([]);
  const [farms, setFarms] = useState([]);


  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleEdit = (row) => {
    setCurrentRow(row);
    setEditIndex(row.id - 1);
    setOpenDialog(true);
  };
  const convertToPolygons = (data) => {
    return data.map((item) => {
      const coordinates = item.lat.map((latVal, i) => ({
        lat: latVal,
        lng: item.lon[i],
      }));
      return {
        areaType: item.landType,
        coordinates,
        appLandId: item.appLandId,
      };
    });
  };

  const fetchLandData = useCallback(async () => {
    if (userData?.registor === 1) {
      try {
        // โหลดข้อมูลฟาร์ม
        const farmsRes = await GetFarm({ appFarmerId: userData.appFarmerId });
        setFarms(farmsRes);
  
        // โหลดข้อมูลแปลงที่ดิน
        const landRes = await GetLand({ appFarmerId: userData.appFarmerId });
        const landIds = extractappLandId(landRes);
        setAppLandIdOptions(landIds);
        setLandPolygons(convertToPolygons(landRes));
  
        // โหลดข้อมูลรอบเพาะปลูก
        const cropRes = await GetCrop({ appLandId: landIds });
        const flatData = Array.isArray(cropRes) ? cropRes.flat() : [];
        setRows(payloadToRow(flatData));
      } catch (error) {
        console.error("Error fetching farmer data:", error);
      }
    }
  }, [userData]);
  

  useEffect(() => {
    fetchLandData();
  }, []);

  const handleDelete = (row) => {
    setRowToDelete(row);
    setDeleteConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!rowToDelete) return;
    try {
      const res = await DeleteCrop({ appCropId: rowToDelete.appCropId });
      if (res.status === 200) {
        setRows((prev) => prev.filter((r) => r.id !== rowToDelete.id));
        setSnackbarSeverity("success");
        setSnackbarMessage("ลบรอบเพาะปลูกสำเร็จ");
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("ลบรอบเพาะปลูกไม่สำเร็จ");
      }
    } catch (err) {
      console.error("Error deleting crop:", err);
      setSnackbarSeverity("error");
      setSnackbarMessage("เกิดข้อผิดพลาดระหว่างลบ");
    }
    setOpenSnackbar(true);
    setDeleteConfirmOpen(false);
    setRowToDelete(null);
  };

  const handleAdd = () => {
    const emptyRow = Object.fromEntries(editableFields.map((f) => [f.key, ""]));
    const newRow = { id: rows.length + 1, ...emptyRow };
    setCurrentRow(newRow);
    setEditIndex(null);
    setOpenDialog(true);
  };

  const handleSave = async () => {
    try {
      if (editIndex !== null) {
        const updated = [...rows];
        updated[editIndex] = currentRow;
        setRows(updated);

        const res = await UpdateCrop(currentRow);
        if (res.status === 200) {
          setSnackbarSeverity("success");
          setSnackbarMessage("อัปเดตรอบเพาะปลูกสำเร็จ");
        } else {
          setSnackbarSeverity("error");
          setSnackbarMessage("อัปเดตรอบไม่สำเร็จ");
        }
      } else {
        const newRow = { ...currentRow, id: rows.length + 1 };
        setRows([...rows, newRow]);

        const res = await CreateCrop(newRow);
        if (res.status === 200) {
          setSnackbarSeverity("success");
          setSnackbarMessage("สร้างรอบเพาะปลูกสำเร็จ");
        } else {
          setSnackbarSeverity("error");
          setSnackbarMessage("สร้างรอบไม่สำเร็จ");
        }
      }
    } catch (err) {
      console.error("เกิดข้อผิดพลาดตอนส่งข้อมูล", err);
      setSnackbarSeverity("error");
      setSnackbarMessage("เกิดข้อผิดพลาดระหว่างบันทึก");
    }
    setOpenSnackbar(true);
    setOpenDialog(false);
  };

  const columns = [
    {
      field: "action",
      headerName: "ตรวจสอบ",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            setSelectedAppCropId(params.row.appCropId);
            setDateCrop(params.row.startDate);
            setMain(false);
          }}
        >
          <IndeterminateCheckBoxIcon sx={{ color: colors.greenAccent[400] }} />
        </IconButton>
      ),
    },
    { field: "id", headerName: "ID", width: 70 },
    ...editableFields.map((f) => ({
      field: f.key,
      headerName: f.label,
      width: 150,
    })),
    {
      field: "actions",
      headerName: "การจัดการ",
      width: 200,
      renderCell: (params) => (
        <Box display="flex" justifyContent="center" mt="10px">
          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleEdit(params.row)}
            >
              แก้ไข
            </Button>
            <Button
              variant="outlined"
              size="small"
              color="error"
              onClick={() => handleDelete(params.row)}
            >
              ลบ
            </Button>
          </Stack>
        </Box>
      ),
    },
  ];

  const renderContent = () => {
    const commonProps = { appCropId: selectedAppCropId };
    switch (selectedMenu) {
      case "manufacturing":
        return <Stock {...commonProps} />;
      case "event":
        return <Event {...commonProps} />;
      case "image_event":
        return <Event_image {...commonProps} />;
      case "durian_interval":
        return <Durian_interval start_date={dateCrop} />;
      case "dork_interval":
        return <DorkStateTable {...commonProps} />;
      default:
        return <Typography>กรุณาเลือกเมนู</Typography>;
    }
  };

  const menuSelection = [
    {
      icon: <HandymanIcon />,
      label: "ปัจจัยการผลิต",
      onClick: () => setSelectedMenu("manufacturing"),
    },
    {
      icon: <LocalActivityIcon />,
      label: "กิจกรรม",
      onClick: () => setSelectedMenu("event"),
    },
    {
      icon: <EventAvailableIcon />,
      label: "ชุดดอก",
      onClick: () => setSelectedMenu("dork_interval"),
    },
    {
      icon: <CalendarMonthIcon />,
      label: "ช่วงทุเรียน",
      onClick: () => setSelectedMenu("durian_interval"),
    },
  ];

  return (
    <>
      {main ? (
        <Box>
          <Box sx={{ m: 2 }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: colors.greenAccent[400] }}
              onClick={handleAdd}
            >
              เพิ่มรอบเพาะปลูก
            </Button>
          </Box>
          <Box sx={{ width: "100%", overflowX: "auto" }}>
            <Box sx={{ height: 500, maxWidth: isMobile ? "360px" : "100%" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSizeOptions={[5]}
                initialState={{
                  pagination: { paginationModel: { pageSize: 5 } },
                }}
                disableRowSelectionOnClick
              />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box>
          <Box display="flex" justifyContent="center">
            <Stack
              direction="row"
              spacing={isMobile ? 0 : 2}
              justifyContent="flex-start"
            >
              {menuSelection.map(({ icon, label, onClick }, index) => {
                const isSelected = selectedIndex === index;
                return (
                  <IconButton
                    key={index}
                    onClick={() => {
                      setSelectedIndex(index);
                      onClick();
                    }}
                    sx={{
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: isMobile ? 50 : 100,
                      backgroundColor: isSelected
                        ? colors.greenAccent[400]
                        : "transparent",
                      color: isSelected ? "#fff" : "inherit",
                      borderRadius: "12px",
                      "&:hover": {
                        backgroundColor: colors.greenAccent[300],
                        color: "#fff",
                      },
                    }}
                  >
                    {React.cloneElement(icon, {
                      sx: {
                        fontSize: isMobile ? "18px" : "28px",
                        color: isSelected ? "#fff" : "inherit",
                      },
                    })}
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: isMobile ? "10px" : "12px",
                        textAlign: "center",
                      }}
                    >
                      {label}
                    </Typography>
                  </IconButton>
                );
              })}
            </Stack>
          </Box>
          <Divider
            sx={{
              my: 2,
              borderBottomWidth: 3,
              width: isMobile ? "90%" : "50%",
              borderColor: colors.greenAccent[400],
              mx: "auto",
            }}
          />
          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              sx={{ backgroundColor: colors.greenAccent[400] }}
              onClick={() => setMain(true)}
            >
              ย้อนกลับ
            </Button>
          </Box>
          {renderContent()}
        </Box>
      )}

      {/* Dialog เพิ่ม/แก้ไข */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{editIndex !== null ? "แก้ไขรอบเพาะปลูก" : "เพิ่มรอบเพาะปลูก"}</DialogTitle>
        <DialogContent>
          {/* เลือกฟาร์ม */}
<TextField
  select
  fullWidth
  label="เลือกฟาร์ม"
  value={currentRow.appFarmId || ""}
  onChange={(e) =>
    setCurrentRow((prev) => ({
      ...prev,
      appFarmId: e.target.value,
      appLandId: "", // reset เมื่อเปลี่ยนฟาร์ม
    }))
  }
  margin="normal"
>
  {farms.map((farm) => (
    <MenuItem key={farm.appFarmId} value={farm.appFarmId}>
      {`${farm.province} - ${farm.amphur} - ${farm.tambon}`}
    </MenuItem>
  ))}
</TextField>
{currentRow.appFarmId && (
            <Box mt={2} height="300px">
              <MapMarkerViewer
                payload={farms.filter((f) => f.appFarmId === currentRow.appFarmId)}
              />
            </Box>
          )}


          {/* เลือก appLandId */}
          <TextField
            select
            fullWidth
            label="เลือกแปลงที่ดิน"
            value={currentRow.appLandId || ""}
            onChange={(e) =>
              setCurrentRow((prev) => ({ ...prev, appLandId: e.target.value }))
            }
            margin="normal"
          >
            {appLandIdOptions.map((id) => (
              <MenuItem key={id} value={id}>
                {id}
              </MenuItem>
            ))}
          </TextField>

          {/* แสดง MapPolygonViewer หลังเลือก appLandId */}
          {currentRow.appLandId && (
            <Box mt={2} height="300px">
              <MapPolygonViewer
                polygons={landPolygons.filter(
                  (p) => p.appLandId === currentRow.appLandId
                )}
              />
            </Box>
          )}

          {/* ฟอร์ม field อื่นๆ */}
          {editableFields
            .filter((f) => f.key !== "appLandId")
            .map((f) => {
              const isDateField = f.key.toLowerCase().includes("date"); // ถ้าชื่อมีคำว่า date ให้ใช้ date picker
              return (
                <TextField
                  key={f.key}
                  fullWidth
                  margin="normal"
                  label={f.label}
                  type={isDateField ? "date" : "text"}
                  InputLabelProps={isDateField ? { shrink: true } : {}}
                  value={currentRow[f.key] || ""}
                  onChange={(e) =>
                    setCurrentRow((prev) => ({ ...prev, [f.key]: e.target.value }))
                  }
                />
              );
            })}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>ยกเลิก</Button>
          <Button onClick={handleSave} variant="contained">
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog ยืนยันการลบ */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
      >
        <DialogTitle>ยืนยันการลบ</DialogTitle>
        <DialogContent>
          <Typography>คุณต้องการลบรอบเพาะปลูกนี้หรือไม่?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirmOpen(false)}>ยกเลิก</Button>
          <Button variant="contained" color="error" onClick={confirmDelete}>
            ตกลง
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar แจ้งเตือน */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
        sx={{
          "& .MuiSnackbarContent-root": {
            justifyContent: "center",
            minWidth: "200px",
            textAlign: "center",
          },
        }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
